import React, { useContext } from 'react';

import { Grid, Hidden, Paper } from '@material-ui/core';
import { navigate } from '@reach/router';

import { GlobalContext } from '../../../../store';
import { IMetaFormat } from '../../../../store/admin/roundFormats/store';

import { sortBy } from '../../../../contrib/sortBy';
import { EventWizardStepTitle } from '../Components/EventWizardStepTitle/EventWizardStepTitle';
import { GameContestFormatCard } from './Components/GameContestFormatCard';
import { GameFormatSelector } from './Components/GameFormatSelector/GameFormatSelector';
import { GameFormatSelectorModal } from './GameFormatSelectorModal';
import { useRouteInfoState } from '../../../../components/RouteInfo/Context/RouteInfo.context';
import { EVENT_SETUP_SECTIONS } from '../EventSetup/Utils/EVENT_SETUP_SECTIONS';

export interface IRoundFormatDrafts {
  [formatId: number]: IMetaFormat[];
}

export const EventFormats = () => {
  const {
    adminRoundFormats: { roundFormats }
  } = useContext(GlobalContext);

  const { clubId, eventId } = useRouteInfoState();

  const nextStep = () => {
    const nextSectionSlug = EVENT_SETUP_SECTIONS[EVENT_SETUP_SECTIONS.formats + 1];

    navigate(`/staff/club/${clubId}/event/${eventId}/setup/${nextSectionSlug}`);
  };

  if (!clubId || !eventId) {
    return <></>;
  }

  return (
    <div className="event-wizard-page form event-formats">
      <EventWizardStepTitle
        buttonText="SAVE & CONTINUE"
        buttonOnClick={nextStep}
        title="GAMES AND CONTESTS"
      />

      <div className="event-formats-container">
        <div className="round-details-section">
          <div className="round-details-subsection">
            <div className="game-formats">
              <Grid className="grid" container={true} spacing={4}>
                <Hidden smDown={true}>
                  <Grid className="grid-item game-format-selector-container" item={true} xs={4}>
                    <Paper elevation={1} className="paper">
                      <GameFormatSelector eventId={eventId} clubId={clubId} />
                    </Paper>
                  </Grid>
                </Hidden>

                <Grid className="grid-item selected-formats-container" item={true} xs={12} md={8}>
                  <Hidden smUp={true}>
                    <GameFormatSelectorModal clubId={clubId} eventId={eventId} />
                  </Hidden>

                  <div className="selected-formats-list">
                    {roundFormats[Number(eventId)] && roundFormats[Number(eventId)].length > 0 ? (
                      <ul className="selected-round-formats">
                        {sortBy(roundFormats[Number(eventId)], 'asc', 'id').map(metaFormat => (
                          <GameContestFormatCard key={metaFormat.id} metaFormat={metaFormat} />
                        ))}
                      </ul>
                    ) : (
                      <div className="empty-format-list">No formats selected</div>
                    )}
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
